import React from 'react';
import { ErrorMessage as PantryErrorMessage } from '@royalaholddelhaize/design-system-pantry-web/components/error-message/error-message';
import { createTestHook } from '../../utils/create-test-hook';
import css from './error-message.module.scss';

export interface ErrorMessageProps {
    text: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ text }) => (
    <PantryErrorMessage
        text={text}
        className={css.root}
        {...createTestHook('error-message')}
    />
);
